import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerAkariTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import type { AkariPresence } from "./Player";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type { AkariDefinition, AkariProgress, AkariSolution, AkariSubmission } from "./types";

registerAkariTranslations(i18n);

export const akariModule: PuzzleTypeModule<
  AkariDefinition,
  AkariSubmission,
  AkariProgress,
  AkariSolution,
  AkariPresence
> = {
  key: "akari",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
